import { type HighlightsController } from '@databases/highlights';
import { createHighlightsEffect } from '@databases/selections';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export interface HighlightsEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createHighlightsEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.HIGHLIGHTS_EFFECT,
    type: 'effect',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE ||
      ctx.layoutType === TABLE_V2_LAYOUT_ID,
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createHighlightsEffect(highlightsController);
    },
  };
}
